import type { InjectionKey } from 'vue'
import type { SuggestionOption } from './useDestinationSearch'

export interface DestinationSearchContext {
  model: Ref<SuggestionOption | undefined>
  query: Ref<string>
  suggestions: ComputedRef<SuggestionOption[]>
  isOpen: Ref<boolean>
  handleFocus: () => void
  handleBlur: () => void
  handleClick: () => void
  handleInput: (event: Event) => void
  handleClear: () => void
  handleClearWithFocus: () => void
}

export const DESTINATION_SEARCH_KEY: InjectionKey<DestinationSearchContext> =
  Symbol('destination-search')

export function provideSearchDestination(
  model: Ref<SuggestionOption | undefined>,
) {
  const {
    query,
    suggestions,
    isOpen,
    handleFocus,
    handleBlur,
    handleClick,
    handleInput,
    handleClear,
  } = useDestinationSearch(model)

  function handleClearWithFocus() {
    handleClear()
  }

  const context: DestinationSearchContext = {
    model,
    query,
    suggestions,
    isOpen,
    handleFocus,
    handleBlur,
    handleClick,
    handleInput,
    handleClear,
    handleClearWithFocus,
  }

  provide(DESTINATION_SEARCH_KEY, context)

  return context
}

export function injectDestinationSearch(): DestinationSearchContext {
  const context = inject(DESTINATION_SEARCH_KEY)

  if (!context) {
    throw new Error(
      'useSearchDestinationProvider must be used within a component that provides destination search context',
    )
  }

  return context
}
